import React from 'react'
import {realPath} from './util'

class DocViewer extends React.Component {
	state = {
		i: 0,
		loaded: false
	}
	componentWillMount = () => {
		this.ri = setInterval(() => {this.reloadDoc()}, 3000)
	}
	componentWillReceiveProps = nextProps => {
		if(this.ri) clearInterval(this.ri)
		this.ri = setInterval(() => {this.reloadDoc()}, 3000)
		this.setState({i: this.state.i+1, loaded: false})
	}
	componentWillUnmount = () => {
		if(this.ri) clearInterval(this.ri)
		this.ri = null
	}
	reloadDoc = () => {
		if(this.state.loaded) return
		this.setState({i: this.state.i+1, loaded: false})
	}
	docLoaded = () => {
		this.setState({loaded: true})
		if(this.ri) clearInterval(this.ri)
		this.ri = null
	}
	render() {
		const {url, classes} = this.props
		const {i, loaded} = this.state
		
		return (
			<div className={'doc-viewer ' + (classes || '') + (loaded?' loaded':' loading')}><div className='content'>
				{!loaded && <div className='loading'><i className="fa fa-spinner fa-spin fa-3x fa-fw"></i></div>}
					<iframe 
						key={i}
						title='document'
						onLoad={this.docLoaded}
						onError={this.reloadDoc}
						width="100%" 
						src={"https://docs.google.com/viewer?url="+encodeURIComponent(realPath(url))+"&embedded=true"}></iframe>
			</div></div>
		)
	}
}
export default DocViewer



// WEBPACK FOOTER //
// ./src/fm/lib/DocViewer.js